import TmLogo from "@assets/tm_logo.webp";
import TmMobileLogo from "@assets/tm_logo_mobile.png";
import { HeaderMmLogo } from "@header/ManavarMurasu/HeaderMmLogo";
import cx from "classnames";
import { twMerge } from "tailwind-merge";
export type MmProps = {
  testId: string;
  sectionName?: string;
  isArticleFirstFoldEnabled?: boolean;
};

export function HeaderLogo({
  testId,
  sectionName,
  isArticleFirstFoldEnabled = false,
}: MmProps) {
  return (
    <div
      className={twMerge(
        "inline-flex m-auto lg:col-start-2 lg:col-span-4 lg:col-end-6 lg:h-20 xs:h-lg",
        isArticleFirstFoldEnabled && "lg:h-17",
      )}
    >
      <a
        data-testid={`${testId}-logo`}
        href="/"
        rel="home"
        title="Tamil Murasu"
      >
        <img
          width={isArticleFirstFoldEnabled ? 349 : 297.5}
          height={isArticleFirstFoldEnabled ? 70 : 68}
          alt="Home"
          src={TmLogo}
          className={cx(
            "hidden lg:block",
            sectionName === "maanavar-murasu" ? "" : "h-17 my-2",
            isArticleFirstFoldEnabled && "!my-0 h-3xl w-[349px]",
          )}
        />
        <img
          width={isArticleFirstFoldEnabled ? 162 : 144}
          height={isArticleFirstFoldEnabled ? 32 : 29.81}
          alt="Home"
          src={TmMobileLogo}
          className={twMerge(
            "lg:hidden block w-36 mr-1",
            isArticleFirstFoldEnabled && "w-[162px] h-8.4 mr-0",
          )}
        />
      </a>

      {sectionName === "maanavar-murasu" && <HeaderMmLogo />}
    </div>
  );
}
